export const COMPONENT_META = Symbol.for('smoothie.ui.componentMeta');
function compareStrings(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
function normalizeMeta(meta) {
    const extensionPoints = meta.extensionPoints
        ? Object.freeze(Array.from(new Set(meta.extensionPoints)))
        : undefined;
    const recipeVariantsInput = meta.recipeVariants;
    const recipeVariants = recipeVariantsInput
        ? Object.freeze(Object.fromEntries(Object.keys(recipeVariantsInput)
            .sort(compareStrings)
            .map((axis) => {
            const values = Array.from(new Set(recipeVariantsInput[axis]));
            return [axis, Object.freeze(values)];
        })))
        : undefined;
    const normalizedMeta = {
        ...meta,
        ...(extensionPoints && { extensionPoints }),
        ...(recipeVariants && { recipeVariants }),
    };
    return Object.freeze(normalizedMeta);
}
function isEquivalentMeta(left, right) {
    if (!left || typeof left !== 'object') {
        return false;
    }
    return JSON.stringify(left) === JSON.stringify(right);
}
/**
 * Attach immutable component metadata to an extendable component function.
 */
export function withComponentMeta(component, meta) {
    const normalizedMeta = normalizeMeta(meta);
    const existingDescriptor = Object.getOwnPropertyDescriptor(component, COMPONENT_META);
    if (existingDescriptor) {
        if (isEquivalentMeta(existingDescriptor.value, normalizedMeta)) {
            return component;
        }
        if (!existingDescriptor.configurable) {
            throw new Error(`Cannot replace non-configurable component metadata for ${normalizedMeta.componentId}.`);
        }
    }
    // Keep metadata immutable and hidden from enumeration, while allowing dev HMR
    // to re-evaluate component index modules without crashing.
    Object.defineProperty(component, COMPONENT_META, {
        value: normalizedMeta,
        writable: false,
        enumerable: false,
        configurable: true,
    });
    return component;
}
/**
 * Read component metadata attached via the framework metadata symbol.
 */
export function getComponentMeta(component) {
    return component[COMPONENT_META];
}
//# sourceMappingURL=component-meta.js.map